import styled from 'styled-components';
import mainColors from '../../../Style-guide/main-colors';

const TabViewWrapper = styled.div`
  width: 100%;

  .tab-view__tabs {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid ${mainColors.text_color};
    user-select: none;
    -webkit-user-select: none;
  }

  .tab-view__tab {
    position: relative;
    padding: 12px;
    border: none;
    background: transparent;
    color: ${mainColors.text_color};
    font-weight: 500;
    cursor: pointer;
    transition: color 0.25s ease;
  }

  .tab-view__tab--active {
    color: ${mainColors.main_color};
  }

  .tab-view__tab--active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${mainColors.main_color};

    animation: tabUnderline 0.25s ease;
  }

  .tab-view__content {
    padding-top: 12px;
  }

  .tab-view__content-inner {
    animation: tabContentIn 0.3s ease;
  }

  @keyframes tabContentIn {
    from {
      opacity: 0;
      transform: translateY(6px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes tabUnderline {
    from {
      transform: scaleX(0);
      transform-origin: left;
    }

    to {
      transform: scaleX(1);
      transform-origin: left;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .tab-view__tab,
    .tab-view__content-inner {
      transition: none;
      animation: none;
    }
  }
`;

export default TabViewWrapper;
